var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormCulturalOrganization", {
                attrs: {
                  data: _vm.culturalOrganization,
                  cities: _vm.cities,
                  loading: _vm.isFormLoading,
                  loadingData: _vm.isMutationLoading,
                  "shared-access": _vm.sharedAccess,
                  "ticket-reservations": _vm.ticketReservations,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.formCulturalOrganisationSubmit,
                  "delete-cultural-organisation":
                    _vm.deleteCulturalOrganization,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  "change:descriptionForMobile": function ($event) {
                    return _vm.changeDescForMobHandler($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmCulturaOrganisationRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }